const one = '{1}';
const two = '{2}';

export const DictionaryExplanations =
{
    header:
    <div>
        <p>
            Dictionary links. While reading a book, highlight a word and click the corresponding button under the sentence.
            Dictionaries can be for a specific language, or general (such as Wiktionary).
        </p>
        <p>
            In the URL, the part where the word goes is represented by "{one}". For Wiktionary, it would be https://en.wiktionary.org/wiki/{one}. Use {two} to insert a <b>lowercase</b> version of the word.
        </p>
    </div>,
    url_pattern:
    <>
        Example: https://en.wiktionary.org/wiki/{one}, or https://en.wiktionary.org/wiki/{two} to make the selected word <b>lowercase</b>
    </>,
};